import { ItemsViewLayoutSwitch } from '@app/components/items-view-layout-switch/ItemsViewLayoutSwitch';
import { useStatusSettingsStore } from '../stores/status-settings.store';
import { useStatusViewToggleTour } from './useStatusViewToggleTour';

/**
 * Button group to switch between list and grid layouts (wide / normal / compact).
 * Uses Zustand store to persist view preference.
 * Shows a one-time tour highlighting the control on first visit.
 * Closing the tour when the user clicks any toggle button.
 */
export function StatusViewToggle() {
  const { closeTour } = useStatusViewToggleTour();

  const view = useStatusSettingsStore((state) => state.view);
  const setView = useStatusSettingsStore((state) => state.setView);

  const handleChange = (newView: Parameters<typeof setView>[0]) => {
    closeTour();
    setView(newView);
  };

  return (
    <ItemsViewLayoutSwitch id="logger-status-view-toggle" value={view} onChange={handleChange} />
  );
}
